import React, { useState, useEffect } from 'react';
import PostHeader from '@components/PostHeader';
import PostMobile from '@components/PostMobile';
import '@styles/BlogBody.css';
const Postjavascript3 = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add Open Graph meta tags for this specific post
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    const post = {
      title: "JavaScript Arrays and Objects",
      date: "November 1, 2023",
      image: "/assets/FeedItems/BBxwtHYtEumaJvAF8ju.svg",
      summary: "Explore the fundamental data structures in JavaScript: arrays and objects. Learn about working with arrays, objects, and iterating over these data structures.",
      path: "blog/technology/javascript/post/postjavascript3"
    };

    document.title = `${post.title} - Cloud CZR`;
    updateMetaTag('og:title', `${post.title} - Cloud CZR`);
    updateMetaTag('og:description', post.summary);
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'article');
    updateMetaTag('og:image', `${window.location.origin}${process.env.PUBLIC_URL}${post.image}`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', post.summary, false);
    updateMetaTag('twitter:title', `${post.title} - Cloud CZR`, false);
    updateMetaTag('twitter:description', post.summary, false);
  }, []);

  const post = {
    title: "JavaScript Arrays and Objects",
    date: "November 1, 2023",
    image: "/assets/FeedItems/BBxwtHYtEumaJvAF8ju.svg",
    summary: "Explore the fundamental data structures in JavaScript: arrays and objects. Learn about working with arrays, objects, and iterating over these data structures.",
    path: "blog/technology/javascript/post/postjavascript3"
  };
  return (
    <div>
      {isDesktop ? (
        <PostHeader post={post} config={{ width: '400px', height: '400px' }} />
      ) : (
        <PostMobile post={post} config={{ width: '400px', height: '400px' }} />
      )}
      <div class="body-gold">
        <p>
          Arrays and objects are two of the most important data structures in JavaScript. They allow you to store and manipulate collections of data, making it easier to work with complex data sets.
        </p>
        <h2>Working with Arrays</h2>
        <p>
          Arrays are ordered collections of values. They can store any type of data, including numbers, strings, and objects. JavaScript provides a variety of methods for working with arrays, such as push, pop, shift, unshift, and splice.
        </p>
        <h2>Working with Objects</h2>
        <p>
          Objects are collections of key-value pairs. They allow you to store related data and functions together. You can access and modify object properties using dot notation or bracket notation.
        </p>
        <h2>Iterating Over Arrays and Objects</h2>
        <p>
          JavaScript provides several ways to iterate over arrays and objects, including for loops, forEach, map, and for...in loops. Understanding how to iterate over these data structures is essential for working with complex data sets.
        </p>
        <p>
          Arrays and objects are fundamental data structures in JavaScript. By mastering these concepts, you can work with complex data sets and create more efficient and effective code.
        </p>
      </div>
    </div>
  );
};

export default Postjavascript3;